import React, { useEffect, useRef } from 'react';

interface ContextMenuProps {
    position: { x: number; y: number };
    onClose: () => void;
    children: React.ReactNode;
}

interface MenuItemProps {
    onClick: () => void;
    children: React.ReactNode;
    className?: string;
}

export const ContextMenu: React.FC<ContextMenuProps> = ({ position, onClose, children }) => {
    const menuRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
                onClose();
            }
        };

        const handleEscape = (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
                onClose();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('keydown', handleEscape);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('keydown', handleEscape);
        };
    }, [onClose]);

    return (
        <div
            ref={menuRef}
            className="fixed bg-surface border border-gray-200 rounded-lg shadow-lg py-1 z-50 min-w-48"
            style={{
                left: position.x,
                top: position.y,
            }}
        >
            {children}
        </div>
    );
};

export const MenuItem: React.FC<MenuItemProps> = ({ onClick, children, className = "" }) => {
    return (
        <div
            onClick={onClick}
            className={`px-3 py-2 text-sm cursor-pointer hover:bg-gray-100 transition-colors duration-150 ${className}`}
        >
            {children}
        </div>
    );
};
